module.exports = __webpack_public_path__ + "img/checked.a4633461.svg";